import moment from 'moment';
import React from 'react';
import TimelineChart, {
  TimelineChartDataPoint,
} from '../../../../components/voxel/Charts/TimelineChart';
import { ForwardedChartProps } from './ProgressDashboardSite';
import { DataPoint } from './models';

export interface ProgressDashboardSiteChartWeightedRankProps {
  progressAnalysisData: DataPoint[];
  timelineChartProps: ForwardedChartProps;
}

export const ProgressDashboardSiteChartWeightedRank: React.FC<ProgressDashboardSiteChartWeightedRankProps> =
  ({ progressAnalysisData, timelineChartProps }) => {
    const dataSeries: TimelineChartDataPoint[][] = React.useMemo(
      () => [
        progressAnalysisData?.map(
          (data): TimelineChartDataPoint => ({
            date: moment(data.scheduledTime).toDate(),
            value: data.weightedAverageRank,
          })
        ),
      ],
      [progressAnalysisData]
    );

    if (!progressAnalysisData?.length) return null;

    return (
      <TimelineChart
        dataSeries={dataSeries}
        yMinPlaceholder={1}
        yMaxPlaceholder={100}
        yLabelTooltip="Weighted rank"
        reverseY
        disableArea
        {...timelineChartProps}
      />
    );
  };

export default ProgressDashboardSiteChartWeightedRank;
